import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';

const ConfigContext = createContext(null);

/**
 * Fetches /api/config once at app mount.
 * Exposes the 10 judging feature flags to the whole tree.
 */
export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.get('/config')
      .then((res) => {
        if (!cancelled) {
          setConfig(res.data || {});
          setLoaded(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          // Fail closed: treat all flags as false
          setConfig({
            judging_phase1_enabled: false,
            judging_phase2_enabled: false,
            judging_phase3_enabled: false,
            judging_raw_upload_enabled: false,
            judging_finalist_email_enabled: false,
            judging_judge_notifications_enabled: false,
            judging_monitoring_v1_enabled: false,
            judging_monitoring_v2_enabled: false,
            judging_awards_enabled: false,
            judging_best_of_show_enabled: false,
            preview_admin_overrides: false,
            current_judging_phase: 1,
          });
          setLoaded(true);
        }
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <ConfigContext.Provider value={{ config, loaded }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const ctx = useContext(ConfigContext);
  if (!ctx) throw new Error('useConfig must be used within ConfigProvider');
  return ctx;
};
